<template>
  <div>
    <headerSection :menuData="menuData" />

    <div class="d-flex">

      <!-- sidebar (desktop only) -->
      <Sidebar
        :menuData="menuData"
        v-if="authorized"
        class="d-none d-xl-block"
      />

      <!-- main -->
      <div class="contain-main gept_main_bg3 flex-1 p-2 p-xl-4">
        <router-view class="view_contain"></router-view>
      </div>

    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex'
  import headerSection from '@/components/AiHelper/GEPT/headerSection'
  import Sidebar from '@/components/AiHelper/GEPT/sidebar'
  export default {
    name: 'Layout',
    metaInfo: {
      title: 'GEPT'
    },
    components: {
      headerSection,
      Sidebar
    },

    data () {
      return {
        menuData: null
      }
    },

    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints'
      ])
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.contain-main {
  min-height: calc(100vh - 73px);
}
</style>